module.exports = __webpack_public_path__ + "img/bb_g3_t_nose-06.e45fc31f.svg";